/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tiny_Busy_Fireant_MixInputs */

const fr_tiny_busy_fireant_mix = /** @type {(inputs: Tiny_Busy_Fireant_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourcentage (%)`)
};

/**

* @param {Tiny_Busy_Fireant_MixInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tiny_busy_fireant_mix = /** @type {((inputs?: Tiny_Busy_Fireant_MixInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tiny_Busy_Fireant_MixInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tiny_busy_fireant_mix(inputs)
});